module.exports = __webpack_public_path__ + "static/media/036-cross.d8a82cb0.svg";